export default __webpack_public_path__ + "1cd08ebdf1edc4eea457aaca1f9e0468.svg";